Structured information about a candidate in relation to a particular position.
